var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enrolled && _vm.$store.getters.user)?_c('div',[(_vm.eventData.state=='finished' && _vm.eventData.evaluation && !_vm.missingEval)?_c('h4',{attrs:{"align":"center"}},[_vm._v("Evaluation Received - Thanks")]):_vm._e(),_c('div',{staticClass:"elevation-0 theme-button-custom"},[_vm._t("resourceButtons")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }